import React from 'react'

const OwnProductionTraceabilityReportTOSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4479_47395)" />
    <g clipPath="url(#clip0_4479_47395)">
      <path
        d="M35.4003 32.5705C35.5386 32.8807 35.7004 33.1798 35.8843 33.4652L50.367 30.5839C49.7767 28.5095 48.7718 26.5764 47.4131 24.9015C46.0543 23.2265 44.37 21.8446 42.462 20.8391C40.554 19.8337 38.4618 19.2257 36.3121 19.0519C34.1624 18.8781 31.9998 19.142 29.955 19.8279L35.4003 32.5705Z"
        fill="white"
      />
      <path
        d="M35.8413 37.323C34.5784 36.3567 33.583 35.0841 32.9493 33.6257L27.5026 20.875C25.4367 21.9663 23.6351 23.4972 22.2246 25.3598C20.814 27.2225 19.8289 29.3717 19.3385 31.6561C18.8481 33.9405 18.8644 36.3046 19.3861 38.5821C19.9079 40.8595 20.9225 42.995 22.3585 44.838C23.7945 46.6811 25.617 48.1871 27.6977 49.2499C29.7784 50.3127 32.0668 50.9066 34.4018 50.9897C36.7368 51.0728 39.0616 50.6431 41.2126 49.7308C43.3636 48.8186 45.2886 47.446 46.8519 45.7097L35.8413 37.323Z"
        fill="white"
      />
      <path
        d="M38.1536 35.7316L48.4749 43.5982C50.1244 41.0337 51.001 38.0487 51.0003 34.9996C50.998 34.3976 50.962 33.7962 50.8923 33.1982L38.1536 35.7316Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4479_47395"
        x1="34.5455"
        y1="0"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49912D" />
        <stop offset="1" stopColor="#33691E" />
      </linearGradient>
      <clipPath id="clip0_4479_47395">
        <rect width="32" height="32" fill="white" transform="translate(19 19)" />
      </clipPath>
    </defs>
  </svg>
)

export default OwnProductionTraceabilityReportTOSubcategory
